import { render } from "./SwiperBanner.vue?vue&type=template&id=3cea6b8b&scoped=true&ts=true"
import script from "./SwiperBanner.vue?vue&type=script&lang=ts"
export * from "./SwiperBanner.vue?vue&type=script&lang=ts"

import "./SwiperBanner.vue?vue&type=style&index=0&id=3cea6b8b&lang=less&scoped=true"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cea6b8b"]])

export default __exports__